var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 12 14",
    className: "_dm-svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.469 2.969c.289.289.531.867.531 1.281v9a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75V.75A.75.75 0 01.75 0h7c.414 0 .992.242 1.281.531zM8 1.062v2.937h2.937a.98.98 0 00-.172-.32L8.32 1.234A.991.991 0 008 1.062zM11 13V5H7.75A.75.75 0 017 4.25V1H1v12h10zm-1-3.5V12H2v-1.5L3.5 9l1 1 3-3zM3.5 8a1.5 1.5 0 11.001-3.001A1.5 1.5 0 013.5 8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFile);
export default __webpack_public_path__ + "static/media/ImageFile.1df193c7cde744e54ec82c6fa2b2555c.svg";
export { ForwardRef as ReactComponent };